import { render, staticRenderFns } from "./ModalEditEvent.vue?vue&type=template&id=389947fd&"
import script from "./ModalEditEvent.vue?vue&type=script&lang=js&"
export * from "./ModalEditEvent.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditEvent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports